module.exports = __webpack_public_path__ + "SC05.33a729a2.atlas";